module.exports = "../dist/img/product-detail-1-25.919b.jpg";